<header>
  <div class="d-flex dialog-header">
    <h3 class="dialog-title" translate>
      <div>
          <fa-icon [icon]="['far', 'arrow-alt-circle-right']" transform="shrink-3" class="dialog-title"></fa-icon>
        {{ 'convert_opportunity_to_contract' | translate }}
      </div>
    </h3>
    <div class="ml-auto d-flex">
      <ul class="list-inline pull-right">
        <li class="list-inline-item">
          <button *ngIf="arQuoteLineItem.length" class="btn btn-primary mr-2" (click)="convertRecord()" [disabled]="bDisabled">
            <fa-icon [icon]="['far', 'arrow-alt-circle-right']"></fa-icon>
            <span class="pl-1">{{ 'convert_to_contract' | translate }}</span>
          </button>
          <button type="button" (click)="onCancelDialog()" class="btn btn-danger mr-2">
            <fa-icon [icon]="['fas', 'times']"></fa-icon>
            <span class="pl-1">{{ 'close' | translate }}</span>
          </button>
        </li>
      </ul>
    </div>
  </div>
  <hr />
</header>
<mat-dialog-content>
  <ng-container *ngIf="bFormLoaded; else loading">
    <ng-container *ngIf="arQuoteLineItem.length; else noPrimaryQuote">
      <div class="row mb-3">
        <ng-container *ngFor="let contractFieldKey of arContractFieldKeys; index as i">
          <div class="col-6 mt-2">
            <app-edit-field
              [item]="objContractFields[contractFieldKey]"
              [form]="objContractForm"
              [bSubmitted]="bSubmitted"
              strMode="add"
              [autoSelectResult]="true"
              [strModule]=""
              (parentEvent)="checkQuoteIfEmpty($event)">
            </app-edit-field>
          </div>
        </ng-container>
      </div>
      <div class="row">
        <div class="col-12 mt-1">
          <table class="table border-left border-right border-bottom w-100" style="width: 100% !important;" width="100%">
            <thead>
              <tr>
                <td width="20%" colspan="2"></td>
                <td width="25%" class="align-center">
                  {{ 'description' | translate  }}
                </td>
                <td width="15%" class="align-center">
                  {{ 'quantity' | translate }}
                </td>
                <td width="15%" class="align-center">
                  {{ 'annual_price' | translate }}
                </td>
                <td width="15%" class="align-center">
                  {{ 'total' | translate }}
                </td>
                <td width="10%" class="align-center">
                  {{ 'add_to_recurring_invoice' | translate }}
                  <fa-icon [icon]="['fas', 'info-circle']" class="pointer pl-1 text-primary" matTooltip="{{ 'toggled_recurring_invoice' | translate }}"></fa-icon>
                </td>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let lineItem of arQuoteLineItem; index as index">
                <ng-container *ngIf="lineItem.is_group; else defaultLineItem">
                  <tr>
                    <td width="5%" class="align-center">
                      <input
                        type="checkbox"
                        class="cursor-pointer"
                        [(ngModel)]="lineItem.is_checked"
                        (change)="onChangeCheckbox($event, lineItem)"
                      />
                    </td>
                    <td width="95%" colspan="6">
                      {{ lineItem.label }}
                    </td>
                  </tr>
                </ng-container>
                <ng-template #defaultLineItem>
                  <tr>
                    <td width="5%" class="align-center">
                      <input
                        type="checkbox"
                        class="cursor-pointer"
                        [(ngModel)]="lineItem.is_checked"
                        (change)="onChangeCheckbox($event, lineItem)"
                      />
                    </td>
                    <td width="15%"></td>
                    <td width="25%" class="align-center">
                      {{ lineItem.description }}
                    </td>
                    <td width="15%" class="align-center">
                      {{ lineItem.quantity }}
                    </td>
                    <td width="15%" class="align-center">
                      {{ lineItem.unit_price | currency }}
                    </td>
                    <td width="15%" class="align-center">
                      {{ lineItem.line_item | currency }}
                    </td>
                    <td width="10%" class="align-center">
                      <mat-slide-toggle
                        [(ngModel)]="lineItem.is_invoice"
                        ngDefaultControl
                        color="primary"
                        (change)="markAsConvertToInvoice(lineItem)"
                      ></mat-slide-toggle>
                    </td>
                  </tr>
                </ng-template>
              </ng-container>
            </tbody>
          </table>
          <div *ngIf="hasConvertRecurringInvoice">
            <ng-container [ngTemplateOutlet]="recurringInvoiceForm"></ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</mat-dialog-content>

<ng-template #loading>
  <div class="col-12 text-center">
    <fa-icon [icon]="['fas','spinner']" [spin]="true" aria-hidden="true" class="pr-1"></fa-icon>
  </div>
</ng-template>

<ng-template #noPrimaryQuote>
  <div class="col-12 text-center">
    {{ 'no_asset_type_on_primary_quote_line_item' | translate }}
  </div>
</ng-template>

<ng-template #recurringInvoiceForm>
  <form [formGroup]="objRIFormGroup">
    <table class="table border-left border-right border-bottom w-100" width="100%">
      <thead>
        <tr>
          <td colspan="4" class="text-center">
            {{ 'recurring_invoice' | translate }}
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td width="25%">
            <div class="form-group mb-0">
              <label>{{ 'repeated_every' | translate }}<required-tag></required-tag></label>
              <ng-select
                formControlName="repeated_every"
                [items]="arRepeatedEvery"
                [clearable]="false"
                class="value-text"
                bindLabel="text"
                bindValue="id"
                appendTo="body"
                [ngClass]="{'is-invalid': isValidFormControl('repeated_every')}"
              >
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <span class="ng-value-label">{{ item.text | translate }}</span>
                </ng-template>
                <ng-template  ng-option-tmp let-item="item">
                  <span class="value-text"> {{ item.text | translate }}</span>
                </ng-template>
              </ng-select>
            </div>
          </td>
          <td width="25%">
            <div class="form-group mb-0">
              <label>{{ 'next_invoice_date' | translate }}<required-tag></required-tag></label>
              <div class="input-group">
                <input
                  formControlName="next_invoice_date"
                  [owlDateTime]="objFieldNextInvoiceDate"
                  [required]="true"
                  [readonly]="true"
                  type="text"
                  id="next_invoice_date_txt"
                  class="form-control date-input"
                  [ngClass]="{'is-invalid': isValidFormControl('next_invoice_date')}"
                />
                <button class="calendar-button" type="button" [owlDateTimeTrigger]="objFieldNextInvoiceDate">
                  <fa-icon [icon]="['fal', 'calendar']" style="color:#fff;" ></fa-icon>
                </button>
              </div>
              <div><owl-date-time #objFieldNextInvoiceDate pickerType="calendar"></owl-date-time></div>
            </div>
          </td>
          <td width="25%">
            <div class="form-group mb-0">
              <label>{{ 'invoice_date' | translate }}<required-tag></required-tag></label>
              <ng-select
                formControlName="invoice_date"
                [items]="arInvoicedDate"
                [clearable]="false"
                class="value-text"
                bindLabel="text"
                bindValue="id"
                appendTo="body"
                [ngClass]="{'is-invalid': isValidFormControl('invoice_date')}"
              >
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <span class="ng-value-label">{{ item.text | translate }}</span>
                </ng-template>
                <ng-template  ng-option-tmp let-item="item">
                  <span class="value-text"> {{ item.text | translate }}</span>
                </ng-template>
              </ng-select>
            </div>
          </td>
          <td width="25%">
            <div class="form-group mb-0">
              <label>{{ 'due_date' | translate }}<required-tag></required-tag></label>
              <ng-select
                formControlName="payment_terms_id"
                (open)="objPaymentTerms.loadDataOnClick()"
                [items]="objPaymentTerms.source | async"
                [loading]="objPaymentTerms.loader"
                [typeahead]="objPaymentTerms.typehead"
                [clearable]="false"
                bindLabel="text"
                bindValue="id"
                appendTo="body"
                [ngClass]="{'is-invalid': isValidFormControl('payment_terms_id')}"
              ></ng-select>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </form>
</ng-template>